class OnboardingFrequency extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.urlDiscountCode = this.#getUrlDiscountCode();
    this.#addEventListeners();
  }

  #getUrlDiscountCode() {
    const urlParams = new URLSearchParams(window.location.search);
    const discountCode = urlParams.get('discount_code') || urlParams.get('discount');

    if (discountCode && discountCode.toUpperCase().startsWith('CGC-')) {
      return discountCode.toUpperCase();
    }

    return null;
  }

  #addEventListeners() {
    const backButton = this.querySelector('.back-button');
    backButton.addEventListener('click', () => {
      this.#showComparisonTable();
    });

    const sellingPlans = this.querySelectorAll('.selling_plan');
    sellingPlans.forEach((sellingPlan) => {
      sellingPlan.addEventListener('click', () => {
        this.selectedVariant = sellingPlan.dataset.variantId;
        this.selectedSellingPlan = sellingPlan.dataset.sellingPlanId;
        this.nextProductVariantId = sellingPlan.dataset.nextProductVariant;
        this.selectedDiscount = this.urlDiscountCode || sellingPlan.dataset.discountCode;

        const frequencyRaw = sellingPlan.dataset.frequency;
        const frequencyProcessed = this.#processEventValue(frequencyRaw);

        this.#addToCart(sellingPlan);
        this.#fireEvents("frequency_selected", frequencyProcessed);
      });
    });
  }

  #showComparisonTable() {
    const quiz = this.closest('onboarding-quiz');
    const comparisonTable = quiz.querySelector(`comparison-table[data-step="${this.dataset.from}"]`);

    this.classList.add("hidden");
    comparisonTable.classList.remove("hidden");

    window.dispatchEvent(new CustomEvent('change-checkout-step', { detail: { step: 2 } }));
  }

  async #addToCart(element) {
    if (!this.selectedVariant || !this.selectedSellingPlan) {
      return;
    }

    element.setAttribute('disabled', 'disabled');
    element.classList.add('loading');
    element.querySelector('.loading__spinner').classList.remove('hidden');

    try {
      const signupConfig = {
        mainProduct: {
          variantId: this.selectedVariant,
          sellingPlanId: this.selectedSellingPlan,
        },
        ...this.nextProductVariantId ? {nextProduct: {variantId: this.nextProductVariantId}} : {},
        discountCode: this.selectedDiscount,
      };

      const subscriptionCart = new SubscriptionCart();
      await subscriptionCart.checkout(signupConfig, true);
    } catch (error) {
      console.log('Error adding to cart:', error);
    } finally {
      element.removeAttribute('disabled');
      element.classList.remove('loading');
      element.querySelector('.loading__spinner').classList.add('hidden');
    }
  }

  #fireEvents(eventAction, eventValue) {
    window.dataLayer.push({
      event: 'site_interaction',
      context: 'quiz_selection',
      action: eventAction,
      value: eventValue
    });
  }

  #processEventValue(value) {
    const numberValue = value.split(" ")[0];

    switch (Number(numberValue)) {
      case 1: 
        return "monthly";
      case 2:
        return "bimonthly";
      case 3:
        return "quarterly";
      default:
        return `every ${value}`;
    }
  }
}

if (!customElements.get('onboarding-frequency')) {
  window.customElements.define('onboarding-frequency', OnboardingFrequency);
}
